import CloudOffIcon from '@mui/icons-material/CloudOff';
import CloudQueueIcon from '@mui/icons-material/CloudQueue';
import LockIcon from '@mui/icons-material/Lock';
import { Tooltip, Typography } from "@mui/material";
import { SimType } from "../entity/Device";
import { Utility } from "../utils/Utility";

export class DeviceUiConverter {

  // 電池残量の色付き文字列を取得
  public static getRemainingBatteryColoredString = (battery: string, defaultColorCode?: string, fontSize?: string, isBold?: boolean, reverse?: boolean) => {

    // 空文字列の場合は処理を省略
    if (battery === null || battery === "") {
      return battery;
    }

    // 文字列の前処理
    const batteryNumberString = battery.replace("%", "");
    const batteryNumber = parseInt(batteryNumberString);
    if (Number.isNaN(batteryNumber)) {
      return battery;
    }

    let colorCode = "";
    isBold = (isBold !== null) ? isBold : false;

    if (batteryNumber <= 20) {
      colorCode = "red";
    } else {
      colorCode = (defaultColorCode !== null && defaultColorCode !== "") ? defaultColorCode! : "black";
      colorCode = (reverse && colorCode === "black") ? "dimgrey" : colorCode;
    }

    return (reverse) ? (
      <>
        <Typography
          color={"white"} 
          display={"inline-block"} 
          fontSize={fontSize}
          fontWeight={(isBold) ? "bold" : ""}
          sx={{ backgroundColor: colorCode }}
        >
          {battery}
        </Typography>
      </>
    ) : (
      <>
        <Typography
          color={colorCode} 
          fontSize={fontSize}
          fontWeight={(isBold) ? "bold" : ""}
        >
          {battery}
        </Typography>
      </>
    );

  }

  // 電池残量のiconを取得
  public static getRemainingBatteryIcon = (battery: string, signalUpdateData: string) => {

    // 空文字列の場合は処理を省略
    if (battery === null || battery === "") {
      return <Typography style={{ marginLeft: "22px" }}>-</Typography>;
    }

    // 文字列の前処理
    const batteryNumber = parseInt(battery);

    if (Number.isNaN(batteryNumber)) {
      return battery;
    }
  
    const batteryLevel = Math.floor(batteryNumber / 10) * 10;
        
    const color = batteryLevel < 20  ? "red" : "green" ;
    
    const balloonMsg = battery + "%";

    //電池残量が0の場合、battery_noneを表示
    //電池残量が1~9の場合、battery_010_redを表示
    //電池残量が100の場合、battery_100_greenを表示
    //ほかの場合、それぞれのiconを表示
    if(batteryNumber === 0){
      return (
        <div>
          <Tooltip
              title={balloonMsg}
              placement={"top-end"}
          >
              <img style={{ marginLeft: "8px", height: "25px" }} src = {"/images/common/battery/battery_none.svg"}></img>
          </Tooltip>
        </div>
      );
    }
    else if(batteryNumber > 0 && batteryNumber <= 9 ){
      return (
        <div>
          <Tooltip
              title={balloonMsg}
              placement={"top-end"}
          >
              <img style={{ marginLeft: "8px", height: "25px" }} src = {"/images/common/battery/battery_010_red.svg"}></img>
          </Tooltip>
        </div>
      );
    }

    switch(batteryLevel){       
      case 100 :
        return (
          <div>
            <Tooltip
                title={balloonMsg}
                placement={"top-end"}
            >
            <img style={{ marginLeft: "8px", height: "25px" }}  src = {`/images/common/battery/battery_${batteryLevel}_${color}.svg`}></img>
            </Tooltip>
          </div>
        );
      default :
        return (
          <div>
            <Tooltip
                title={balloonMsg}
                placement={"top-end"}
            >
            <img style={{ marginLeft: "8px", height: "25px" }}  src = {`/images/common/battery/battery_0${batteryLevel}_${color}.svg`}></img>
            </Tooltip>
          </div>
        );
      }  
  }

  // 電波強度のiconを取得
  public static getSingignalLevelIcon = (signalLevel: string, signalUpdateData: string, status: string, model: string, sysmodeType: string) => {

    // 空文字列の場合は処理を省略
    // 機種が未設定時、電波強度アイコンは「-」を表示
    if (model === null || model === "") {
      return <Typography style={{ marginLeft: "12px" }}>-</Typography>;
    }  
    
    //デバイスがオンライン、そしてsignalDetailの情報がない場合、<Typography style={{ marginLeft: "22px" }}>-</Typography>を表示
    //デバイスがオフライン、disconnectedを表示
    if(status === "オンライン" && (sysmodeType === null || sysmodeType === "")){
      return <Typography style={{ marginLeft: "12px" }}>-</Typography>;
    }
    else if(status === "オフライン"){
      return (
        <div>
          <img style={{ marginLeft: "2px", height: "25px"}} src = {"/images/common/signal/signal_disconnected_red.svg"}></img>                                                         
        </div>
      )
    }

    //通信設定を取得
    let sysmode = ""
    
    if(model === "FS010M"){
      if(sysmodeType === "3G"){
        sysmode = "1"
      }else{
        sysmode = "2"
      }
    }
    else if (model === "FS050W" || model === "FS045W" || model === "FS045U"){
      sysmode = sysmodeType
    }

    //取得日時の処理
    var balloonMsg = "取得日時：" + Utility.dateFormatYmdHi(signalUpdateData);

    //通信設定と電波強度のレベル（閾値での判定後の値）によってアイコンを表示
    if(sysmode === "0"){
      return (
          <div>
              <img style={{ marginLeft: "2px", height: "25px" }} src = {"/images/common/signal/signal_disconnected_red.svg"}></img>    
          </div>
        );
    }
    else if(sysmode === "1"){
      switch(signalLevel){
        case "x" : 
          return (
            <div>
              <img style={{ marginLeft: "2px", height: "25px" }} src = {"/images/common/signal/signal_disconnected_red.svg"}></img>                                                           
            </div>
         );
        case "0" :
        case "1" :
        case "2" :
        case "3" : 
        case "4" : 
          return (
            <div>
              <Tooltip
                title={balloonMsg}
                placement={"top-end"}
              >
                <img style={{ marginLeft: "2px", height: "25px" }} src = {`/images/common/signal/signal_${signalLevel}_3G.svg`}></img>    
              </Tooltip>
            </div>
         );
        }
      }
    else if(sysmode === "2"){
      switch(signalLevel){
        case "x" : 
          return (
            <div>
              <img style={{ marginLeft: "2px", height: "25px" }} src = {"/images/common/signal/signal_disconnected_red.svg"}></img>                                                        
            </div>
         );
        case "0" :
        case "1" :
        case "2" :
        case "3" : 
        case "4" : 
          return (
            <div>
              <Tooltip
                title={balloonMsg}
                placement={"top-end"}
              >
                <img style={{ marginLeft: "2px", height: "25px" }} src = {`/images/common/signal/signal_${signalLevel}_4G.svg`}></img>    
              </Tooltip>
            </div>
          );
        }
      }
    else if(sysmode === "3"){
      switch(signalLevel){
        case "x" : 
            return (
              <div>
                <img style={{ marginLeft: "2px", height: "25px" }} src = {"/images/common/signal/signal_disconnected_red.svg"}></img>                                                        
              </div>
         );
        case "0" :
        case "1" :
        case "2" :
        case "3" : 
        case "4" : 
          return (
            <div>
              <Tooltip
                title={balloonMsg}
                placement={"top-end"}
                >
                  <img style={{ marginLeft: "2px", height: "25px" }} src = {`/images/common/signal/signal_${signalLevel}_5G.svg`}></img>    
              </Tooltip>
            </div>
         );
      }
    }
  }

  // ロックアイコンを取得
  public static getLockIcon = (isLock: boolean, fontSize?: string) => {
    const iconStyle = {
      display: 'flex',
      alignItems: 'center',
      marginLeft: '2.5px'
    };

    if (isLock === null || isLock === undefined) {
      return <Typography style={{ marginLeft: "7px" }}>-</Typography>;
    }
    if (isLock) {
      return (
        <div style={iconStyle}>
          <Tooltip title="有効">
            <LockIcon style={{ padding: '2px 0px', marginLeft: '-2px', height: "25px", opacity: 0.85, fontSize: "1.5em" }} />
          </Tooltip>
        </div>
      );
    } else {
      return (
        <span style={{ color: "#333", fontSize: "0.85em", padding: '2px 4px' }}>無効</span>
      );
    }
  }

  // キャリアの色を取得
  public static getCarrierColored = (carrier: string, defaultColorCode: string) => {
    const carrierLower = carrier ? carrier.toLowerCase() : '';

    if (carrierLower.includes('au')) return '#eb5505';
    if (carrierLower.includes('docomo')) return '#cc0033';
    if (carrierLower.includes('rakuten')) return '#ff008c';
    if (carrierLower.includes('softbank')) return '#77787a';

    return defaultColorCode || '#333';
  };

  // キャリアの色付き文字列を取得
  public static getCarrierColoredString = (carrier: string, defaultColorCode?: string, fontSize?: string, isBold?: boolean, reverse?: boolean, marginLeft?: string) => {
  
      let colorCode = "";
      const carrierLower = (carrier !== null && carrier !== "") ? carrier.toLowerCase() : "";
      isBold = (isBold !== null) ? isBold : false;
      reverse = (reverse !== null) ? reverse : false;
  
      if (carrierLower.includes("au")) {
        colorCode = "#eb5505";
      } else if (carrierLower.includes("docomo")) {
        colorCode = "#cc0033";
      } else if (carrierLower.includes("rakuten")) {
        colorCode = "#ff008c";
      } else if (carrierLower.includes("softbank")) {
        colorCode = "#77787a";
      } else {
        colorCode = (defaultColorCode !== null && defaultColorCode !== "") ? defaultColorCode! : "black";
        colorCode = (reverse && colorCode === "black") ? "dimgrey" : colorCode;
      }
  
      return (reverse) ? (
        <>
          <Typography 
            color={"white"} 
            display={"inline-block"} 
            fontSize={fontSize}
            fontWeight={(isBold) ? "bold" : ""}
            sx={{ backgroundColor: colorCode }}
          >
            {carrier}
          </Typography>
        </>
      ) : (
        <>
          <Typography 
            color={colorCode} 
            fontSize={fontSize}
            fontWeight={(isBold) ? "bold" : ""}
          >
            {carrier}
          </Typography>
        </>
      );
  
    }

  // 通信ロックの色付き文字列を取得
  public static getCommunicationLockColoredString = (isLock: boolean, defaultColorCode?: string, fontSize?: string, isBold?: boolean, reverse?: boolean) => {

    const lockString = (isLock) ? "有効" : "無効";
    let colorCode = "";
    isBold = (isBold !== null) ? isBold : false;

    if (isLock) {
      colorCode = "red";
    } else {
      colorCode = (defaultColorCode !== null && defaultColorCode !== "") ? defaultColorCode! : "black";
      colorCode = (reverse && colorCode === "black") ? "dimgrey" : colorCode;
    }

    return (reverse) ? (
      <>
        <Typography
          color={"white"} 
          display={"inline-block"} 
          fontSize={fontSize}
          fontWeight={(isBold) ? "bold" : ""}
          sx={{ backgroundColor: colorCode }}
        >
          {lockString}
        </Typography>
      </>
    ) : (
      <>
        <Typography
          color={colorCode} 
          fontSize={fontSize}
          fontWeight={(isBold) ? "bold" : ""}
        >
          {lockString}
        </Typography>
      </>
    );

  }

  // オンライン・オフラインアイコンの取得
  public static getNetworkStatusIcon = (status: string, fontSize?: string) => {
      const iconStyle = {
          display: 'flex',
          alignItems: 'center',
          marginLeft: '2.5px' 
      };
  
      switch(status) {
        case "オンライン":
          return (
            <div style={iconStyle}>
              <Tooltip title="オンライン">
              <CloudQueueIcon sx={{ color: "green", fontSize: fontSize }} />
              </Tooltip>
            </div>
          );
        case "オフライン":
          return (
            <div style={iconStyle}>
              <Tooltip title="オフライン">
              <CloudOffIcon sx={{ color: "red", fontSize: fontSize }} />
              </Tooltip>
            </div>
          );
        default:
          return (
            <div style={iconStyle}>
              <CloudOffIcon sx={{ color: "transparent", fontSize: fontSize }} />
            </div>
          );
      }
  }

  // WebUI ロックの色付き文字列を取得
  public static getWebuiLockColoredString = (isLock: boolean, defaultColorCode?: string, fontSize?: string, isBold?: boolean, reverse?: boolean) => {

    const lockString = (isLock) ? "有効" : "無効";
    let colorCode = "";
    isBold = (isBold !== null) ? isBold : false;

    if (isLock) {
      colorCode = "red";
    } else {
      colorCode = (defaultColorCode !== null && defaultColorCode !== "") ? defaultColorCode! : "black";
      colorCode = (reverse && colorCode === "black") ? "dimgrey" : colorCode;
    }

    return (reverse) ? (
      <>
        <Typography
          color={"white"} 
          display={"inline-block"} 
          fontSize={fontSize}
          fontWeight={(isBold) ? "bold" : ""}
          sx={{ backgroundColor: colorCode }}
        >
          {lockString}
        </Typography>
      </>
    ) : (
      <>
        <Typography
          color={colorCode} 
          fontSize={fontSize}
          fontWeight={(isBold) ? "bold" : ""}
        >
          {lockString}
        </Typography>
      </>
    );

  }

  // 状態の文字列を取得
  public static SimTypeString: Readonly<Record<SimType, string>> = {
    "0": "SIM",
    "1": "eSIM",
    "SIM": "SIM",
    "SIM1": "SIM1",
    "SIM2": "SIM2",
    "eSIM": "eSIM",
    "unknown": "-"
  }

  // 状態の文字列を取得（FS045U用）
  public static SimTypeStringFS045U: Readonly<Record<string, string>> = {
    "0": "SIM1",
    "1": "eSIM",
    "2": "SIM2",
    "SIM1": "SIM1",
    "SIM2": "SIM2",
    "eSIM": "eSIM",
    "unknown": "-"
  }

  public static getSimTypeColor = (type: SimType) => {
    return "#777777";
  }

  public static getSimTypeColorInvert = (type: SimType) => {
    switch (type) {
      case "0":
      case "SIM":
      case "SIM1":
      case "SIM2":
        return true;
      case "1":
      case "eSIM":
        return false;
      default:
        return false;
    }
  }

  public static getSimTypePadding = (type: SimType) => {
    switch (type) {
      case "0":
      case "SIM":
        return "0.03em 0.44em";
      case "1":
      case "eSIM":
        return "0.1em 0.2em";
      case "SIM1":
      case "SIM2":
        return "0.03em 0.15em";
      default:
        return "0.03em 0.44em";
    }
  }
}
